module.exports = __webpack_public_path__ + "static/media/3DPPA8.8e5ef4c2.jpg";